// 9fbef606107a605d69c0edbcd8029e5d
import QUICK_VIEW_CONSTANT from './QuickViewModal.constants';

export const setQuickView = (payload) => {
  return {
    type: QUICK_VIEW_CONSTANT.SET_QUICK_VIEW,
    payload,
  };
};

export const setMultiPackDetails = (payload) => {
  return {
    type: QUICK_VIEW_CONSTANT.SET_MULTIPRODUCT_DETAILS,
    payload,
  };
};

export const setDisableSelectedTab = (payload) => {
  return {
    type: QUICK_VIEW_CONSTANT.SET_DISABLE_SELECTED_TAB,
    payload,
  };
};

export const setItemFromBagInfoForQuickView = (payload) => {
  return {
    type: QUICK_VIEW_CONSTANT.SET_ITEM_FROM_BAG_INFO,
    payload,
  };
};

export const singlePageLoadAction = (payload) => {
  return {
    type: QUICK_VIEW_CONSTANT.SINGLE_TAB_STORE,
    payload,
  };
};

export const quickViewSingleLoad = (payload) => {
  return {
    type: QUICK_VIEW_CONSTANT.QUICK_SINGLE_TAB_STORE,
    payload,
  };
};

export const openQuickViewWithValues = (payload) => {
  return {
    payload,
    type: QUICK_VIEW_CONSTANT.FETCH_QUICK_VIEW,
  };
};

export const setModalState = (payload) => {
  return {
    payload,
    type: QUICK_VIEW_CONSTANT.OPEN_QUICK_VIEW_MODAL,
  };
};

export const setShowRatingView = (payload) => {
  return {
    payload,
    type: QUICK_VIEW_CONSTANT.SHOW_RATING_VIEW,
  };
};

export const updateMiniBagCloseStatusQV = (payload) => ({
  type: QUICK_VIEW_CONSTANT.UPDATE_MINIBAG_CLOSE_STATUS,
  payload,
});

export const setQuickViewProductDetailPageTitle = (payload) => {
  return {
    payload,
    type: QUICK_VIEW_CONSTANT.SET_QUICK_VIEW_PRODUCT_TITLE,
  };
};

export const setQuickViewProductImage = (payload) => {
  return {
    payload,
    type: QUICK_VIEW_CONSTANT.SET_QUICK_VIEW_PRODUCT_IMAGE,
  };
};

export const setLoadingState = (payload) => {
  return {
    payload,
    type: QUICK_VIEW_CONSTANT.SET_LOADING_STATE,
  };
};

export const setQVProductID = (payload) => {
  return {
    payload,
    type: QUICK_VIEW_CONSTANT.SET_PRODUCT_QV_ID,
  };
};

export const setLoadingError = (payload) => {
  return {
    payload,
    type: QUICK_VIEW_CONSTANT.SET_LOADING_ERROR,
  };
};

export const closeQuickViewModal = (payload) => {
  return {
    payload,
    type: QUICK_VIEW_CONSTANT.CLOSE_QUICK_VIEW_MODAL,
  };
};

export const saveQVDataForPDP = (payload) => {
  return {
    payload,
    type: QUICK_VIEW_CONSTANT.SAVE_DATA_FOR_PDP,
  };
};

export const resetPDPDataOfQVProduct = () => ({
  type: QUICK_VIEW_CONSTANT.RESET_PDP_QUICK_VIEW_PRODUCT,
});

export const updateAppTypeWithParams = (payload) => {
  return {
    type: QUICK_VIEW_CONSTANT.UPDATE_APP_TYPE_AND_REDIRECT,
    payload,
  };
};

export const fetchModuleX = (payload) => {
  return {
    type: QUICK_VIEW_CONSTANT.FETCH_MODULEX_CONTENT,
    payload,
  };
};

export const setModuleX = (payload) => {
  return {
    type: QUICK_VIEW_CONSTANT.SET_MODULEX_CONTENT,
    payload,
  };
};

export const setBrandName = (payload) => {
  return {
    type: QUICK_VIEW_CONSTANT.SET_BRAND_NAME,
    payload,
  };
};

export const setTotalPrices = (payload) => {
  return {
    type: QUICK_VIEW_CONSTANT.SET_TOTAL_PRICES,
    payload,
  };
};

export const setPreviousScreenAction = (payload) => {
  return {
    type: QUICK_VIEW_CONSTANT.PREVIOUS_SCREEN,
    payload,
  };
};

export const setPreviousScreenIDAction = (payload) => {
  return {
    type: QUICK_VIEW_CONSTANT.PREVIOUS_SCREEN_ID,
    payload,
  };
};

export const setPlpDataForQuickView = (payload) => {
  return {
    type: QUICK_VIEW_CONSTANT.SET_PLP_DATA_FOR_QUICKVIEW,
    payload,
  };
};

export const setSlpDataForQuickView = (payload) => {
  return {
    type: QUICK_VIEW_CONSTANT.SET_SLP_DATA_FOR_QUICKVIEW,
    payload,
  };
};

export const setItemDataForQuickView = (payload) => {
  return {
    type: QUICK_VIEW_CONSTANT.SET_ITEM_DATA_FOR_QUICKVIEW,
    payload,
  };
};

export const resetValueOfBirthdayModule = (payload) => {
  return {
    type: QUICK_VIEW_CONSTANT.RESET_BIRTHDAY_MODULE_VALUE,
    payload,
  };
};

export const resetQuickViewProduct = () => ({
  type: QUICK_VIEW_CONSTANT.RESET_QUICK_VIEW_PRODUCT,
});

export const setSelectedProductData = (payload) => ({
  type: QUICK_VIEW_CONSTANT.SET_SELECTED_PRODUCT_DATA,
  payload,
});

export const getDataOnNewFitsClick = (payload) => ({
  type: QUICK_VIEW_CONSTANT.GET_DATA_ON_NEW_FITS_CLICK,
  payload,
});

export const updateDataOnNewFitsClick = (payload) => ({
  type: QUICK_VIEW_CONSTANT.UPDATE_DATA_ON_NEW_FITS_CLICK,
  payload,
});
